<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-menu"></i> 菜单管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-form :inline="true" :model="searchForm" size="small">
          <el-form-item label="所属商家">
            <el-input 
              v-model="searchForm.shop_name" 
              placeholder="请选择商家"
              prefix-icon="el-icon-shop"
              suffix-icon="el-icon-arrow-down"
              @focus="showShop"
              readonly
              clearable
              class="shop-input"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="addData" icon="el-icon-plus">新增菜单</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total">
            <i class="el-icon-menu"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ totalCount }}</div>
            <div class="stat-label">菜单总数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon top">
            <i class="el-icon-s-home"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ topLevelCount }}</div>
            <div class="stat-label">一级菜单</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon child">
            <i class="el-icon-s-operation"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ childMenuCount }}</div>
            <div class="stat-label">子菜单</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          border
          :data="tableLoadData"
          style="width: 100%"
          row-key="id"
          :tree-props="{children: 'children'}"
          size="medium"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column prop="name" label="菜单名称" min-width="200">
            <!-- <template slot-scope="scope">
              <div class="menu-name">
                <i :class="scope.row.icon || 'el-icon-menu'" class="menu-icon"></i>
                <span>{{ scope.row.name }}</span>
              </div>
            </template> -->
          </el-table-column>
          <el-table-column prop="path" label="路径" min-width="280">
            <template slot-scope="scope">
              <span class="menu-path">{{ scope.row.path || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pid" label="父级ID" width="100" align="center">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.pid === 0 ? 'success' : 'info'">
                {{ scope.row.pid === 0 ? '顶级' : scope.row.pid }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" width="80" align="center">
            <template slot-scope="scope">
              <span class="sort-num">{{ scope.row.sort || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                class="edit-btn"
                @click="handelEdit(scope.row)"
              >
                <i class="el-icon-edit-outline"></i> 编辑
              </el-button>
              <el-button 
                type="text" 
                size="small" 
                class="delete-btn"
                @click="removeRole(scope.row.id)"
              >
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-menu"></i>
        <p>暂无菜单数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>
    </el-card>

    <!-- 新增编辑弹框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogFormVisible" 
      width="550px"
      :close-on-click-modal="false"
      class="alipay-dialog"
      @closed="handleDialogClosed"
    >
      <div class="dialog-content">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="right" size="small">
          <el-form-item label="菜单名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入菜单名称" prefix-icon="el-icon-edit" clearable></el-input>
          </el-form-item>

          <el-form-item label="路径地址">
            <el-input v-model="form.path" placeholder="请输入路径地址，如：/user/list" prefix-icon="el-icon-link" clearable></el-input>
          </el-form-item>

          <el-form-item label="图标">
            <div class="icon-selector">
              <el-input 
                v-model="form.icon" 
                placeholder="请输入图标类名，如：el-icon-menu"
                prefix-icon="el-icon-picture-outline"
                clearable
              ></el-input>
              <div class="icon-preview" v-if="form.icon">
                <i :class="form.icon"></i>
              </div>
            </div>
            <div class="form-tip">
              <i class="el-icon-info"></i> Element UI图标库，点击
              <el-button type="text" size="mini" @click="showIconList">查看图标</el-button>
            </div>
          </el-form-item>

          <el-form-item label="排序号">
            <el-input-number v-model="form.sort" :min="0" :max="999" controls-position="right" style="width: 100%;"></el-input-number>
            <div class="form-tip"><i class="el-icon-info"></i> 数字越小越靠前</div>
          </el-form-item>

          <el-form-item label="上级菜单">
            <el-cascader
              v-model="form.pid"
              style="width: 100%"
              ref="cascaderAddr"
              @change="handlePidChange"
              :props="cascaderProps"
              :options="cateMenus"
              clearable
              placeholder="请选择上级菜单（不选则为顶级菜单）"
            >
              <template slot-scope="{ data }">
                <span>
                  <i :class="data.icon || 'el-icon-menu'"></i>
                  {{ data.name }}
                </span>
              </template>
            </el-cascader>
            <div class="form-tip" v-if="!form.pid || form.pid.length === 0">
              <i class="el-icon-info"></i> 不选择上级菜单将创建为顶级菜单
            </div>
          </el-form-item>
        </el-form>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelForm">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 商家选择弹框 -->
    <eShopList
      :formData="formData1"
      :visible.sync="visible1"
      :title="title1"
      @eventChoose="chooseShop"
      :closeForm="closeForm1"
    />

    <!-- 图标选择弹框 -->
    <el-dialog title="选择图标" :visible.sync="iconDialogVisible" width="800px" class="icon-dialog">
      <div class="icon-grid">
        <div 
          v-for="icon in iconList" 
          :key="icon"
          :class="['icon-item', { active: form.icon === icon }]"
          @click="selectIcon(icon)"
        >
          <i :class="icon"></i>
          <span>{{ icon }}</span>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="iconDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eShopList from "../../common/eShopList.vue";

export default {
  name: "shopModuleList",
  components: { eShopList },
  data() {
    return {
      loading: false,
      
      formData1: {},
      visible1: false,
      title1: '',
      
      cateMenus: [],
      
      // 搜索表单
      searchForm: {
        role_name: '',
        status: 0,
        shop_id: '',
        shop_name: ''
      },
      
      // 统计数据
      totalCount: 0,
      topLevelCount: 0,
      childMenuCount: 0,
      
      // 表格数据
      tableLoadData: [],
      page: 1,
      limit: 10,
      total: 0,
      baseUrl: this.$store.state.defineWebURL,
      id: '',
      
      // 表单数据
      form: {
        path: '',
        name: '',
        url: '',
        module_id: '',
        role_id: '',
        pid: [],
        icon: 'el-icon-menu',
        sort: 1
      },
      
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      },
      
      // 弹框控制
      dialogFormVisible: false,
      dialogTitle: '',
      
      // 级联选择器配置
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: true
      },
      
      // 图标选择
      iconDialogVisible: false,
      iconList: [
        'el-icon-menu', 'el-icon-setting', 'el-icon-user', 'el-icon-s-home',
        'el-icon-document', 'el-icon-picture', 'el-icon-video-play', 'el-icon-news',
        'el-icon-s-marketing', 'el-icon-s-order', 'el-icon-s-shop', 'el-icon-s-tools',
        'el-icon-s-comment', 'el-icon-s-data', 'el-icon-s-flag', 'el-icon-s-promotion',
        'el-icon-star-on', 'el-icon-collection', 'el-icon-folder-opened', 'el-icon-files',
        'el-icon-share', 'el-icon-camera', 'el-icon-phone', 'el-icon-chat-dot-round',
        'el-icon-bell', 'el-icon-wallet', 'el-icon-credit-card', 'el-icon-suitcase'
      ]
    };
  },
  created() {
    this.DataList();
  },
  computed: {
    isEdit() {
      return this.id && this.id !== '';
    }
  },
  methods: {
    // 表格样式配置
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      };
    },
    rowStyle() {
      return {
        cursor: 'pointer'
      };
    },
    
    // 计算统计数据
    calculateStats(data) {
      let total = 0;
      let topLevel = 0;
      let child = 0;
      
      const traverse = (items) => {
        for (const item of items) {
          total++;
          if (item.pid === 0 || !item.pid) {
            topLevel++;
          } else {
            child++;
          }
          if (item.children && item.children.length) {
            traverse(item.children);
          }
        }
      };
      
      traverse(data);
      this.totalCount = total;
      this.topLevelCount = topLevel;
      this.childMenuCount = child;
    },
    
    closeForm1() {
      this.title1 = "";
      this.visible1 = false;
    },
    
    chooseShop(id, name) {
      this.searchForm.shop_id = id;
      this.searchForm.shop_name = name;
    },
    
    showShop() {
      this.title1 = "选择商家";
      this.visible1 = true;
    },
    
    getMenus() {
      let _this = this;
      let params = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        proxy_id: sessionStorage.getItem('proxy_id'),
      };
      this.$axios.getProxyMoudleTree(params).then((res) => {
        if (res.code == 200) {
          _this.cateMenus = res.data;
        }
      });
    },
    
    handlePidChange() {
      // 父级ID变化处理
    },
    
    DataList() {
      this.loading = true;
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        uid: sessionStorage.getItem('uid'),
      };
      
      this.$axios.getProxyMoudleTree(param).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.tableLoadData = res.data || [];
          this.cateMenus = res.data || [];
          this.calculateStats(this.tableLoadData);
        }
      }).catch(error => {
        this.loading = false;
        console.log(error);
      });
    },
    
    handleSizeChange(newSize) {
      this.limit = newSize;
      this.DataList();
    },
    
    handleCurrentChange(newPage) {
      this.page = newPage;
      this.DataList();
    },
    
    addData() {
      this.dialogTitle = '新增菜单';
      this.id = '';
      this.form = {
        path: '',
        name: '',
        url: '',
        module_id: '',
        role_id: '',
        pid: [],
        icon: 'el-icon-menu',
        sort: 1
      };
      this.dialogFormVisible = true;
    },
    
    handelEdit(row) {
      this.dialogTitle = '编辑菜单';
      this.id = row.id;
      this.form.name = row.name;
      this.form.url = row.url || '';
      this.form.path = row.path || '';
      this.form.icon = row.icon || 'el-icon-menu';
      this.form.sort = row.sort || 1;
      this.form.pid = row.pid ? [row.pid] : [];
      this.dialogFormVisible = true;
    },
    
    reset_dialogForm(formName) {
      this.dialogFormVisible = false;
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
    },
    
    cancelForm() {
      this.dialogFormVisible = false;
    },
    
    handleDialogClosed() {
      this.$refs.form?.resetFields();
    },
    
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let tmpPid = 0;
          if (this.form.pid && this.form.pid.length > 0) {
            tmpPid = this.form.pid[this.form.pid.length - 1];
          }
          
          const params = {
            title: this.form.name,
            url: this.form.url || '',
            path: this.form.path || '',
            icon: this.form.icon,
            pid: tmpPid,
            sort: this.form.sort,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token')
          };
          
          if (this.id) {
            params.module_id = this.id;
          }
          
          this.$axios.proxyModuleSave(params).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.DataList();
              this.dialogFormVisible = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    
    searchSubmit() {
      this.DataList();
    },
    
    removeRole() {
      this.$confirm('确定要删除该菜单吗？删除后无法恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$message.success('删除成功');
        this.DataList();
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    
    // 图标选择
    showIconList() {
      this.iconDialogVisible = true;
    },
    
    selectIcon(icon) {
      this.form.icon = icon;
      this.iconDialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 搜索栏样式
.search-bar {
  background: #f8f9fc;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .el-form-item { margin-bottom: 0; }
  .shop-input { width: 240px; }
  .shop-input ::v-deep .el-input__inner { border-radius: 20px; }
  
  .el-button--primary {
    background: #1677ff; border-color: #1677ff; border-radius: 20px; padding: 8px 20px;
    &:hover { background: #4096ff; border-color: #4096ff; }
  }
  .el-button--success {
    background: #00b578; border-color: #00b578; border-radius: 20px; padding: 8px 20px;
    &:hover { background: #1acd8c; border-color: #1acd8c; }
  }
}

// 统计卡片
.stat-cards {
  display: flex; gap: 20px; margin-bottom: 24px; flex-wrap: wrap;
  .stat-card {
    flex: 1; min-width: 150px; background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px; padding: 20px; display: flex; align-items: center; gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); transition: all 0.3s ease;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    .stat-icon {
      width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff;
      &.total { background: linear-gradient(135deg, #1677ff, #4096ff); }
      &.top { background: linear-gradient(135deg, #00b578, #1acd8c); }
      &.child { background: linear-gradient(135deg, #e6a23c, #ebb563); }
    }
    .stat-info {
      .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; line-height: 1.2; }
      .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; }
    }
  }
}

// 表格样式
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }

.menu-name { display: flex; align-items: center; gap: 8px; .menu-icon { font-size: 18px; color: #1677ff; } }
.menu-path { font-family: monospace; font-size: 12px; color: #8c8f98; background: #f5f7fa; padding: 4px 8px; border-radius: 4px; display: inline-block; }
.sort-num { font-family: monospace; color: #e6a23c; font-weight: 500; }
.edit-btn { color: #1677ff; margin-right: 12px; i { margin-right: 4px; } &:hover { color: #4096ff; } }
.delete-btn { color: #ff4d4f; i { margin-right: 4px; } &:hover { color: #ff7875; } }

.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } .el-button { margin-top: 20px; border-radius: 20px; } }

// 弹框样式
.alipay-dialog .el-dialog {
  border-radius: 20px; overflow: hidden; box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  .el-dialog__header { background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%); padding: 20px 24px; .el-dialog__title { color: #fff; font-size: 18px; font-weight: 500; } }
  .el-dialog__body { padding: 24px; }
  .el-dialog__footer { padding: 16px 24px 24px; border-top: 1px solid #f0f0f0; }
}

.dialog-content .el-form-item { margin-bottom: 22px; }
.dialog-content .el-form-item .el-form-item__label { font-weight: 500; color: #1f2d3d; }
.dialog-content .el-input__inner, .dialog-content .el-textarea__inner { border-radius: 8px; border-color: #e4e7ed; transition: all 0.2s; &:focus { border-color: #1677ff; box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1); } }

.icon-selector { display: flex; gap: 12px; align-items: center; .el-input { flex: 1; } .icon-preview { width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; background: #f5f7fa; border-radius: 8px; font-size: 20px; color: #1677ff; } }
.form-tip { margin-top: 6px; font-size: 12px; color: #8c8f98; i { margin-right: 4px; color: #1677ff; } }

.dialog-footer {
  display: flex; justify-content: flex-end; gap: 12px;
  .el-button { border-radius: 20px; padding: 9px 24px; }
  .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
}

// 图标选择弹框
.icon-grid {
  display: grid; grid-template-columns: repeat(6, 1fr); gap: 12px; max-height: 400px; overflow-y: auto; padding: 8px;
  .icon-item {
    display: flex; flex-direction: column; align-items: center; padding: 12px 8px; border-radius: 8px; cursor: pointer; transition: all 0.2s; background: #f8f9fc;
    &:hover { background: #e6f4ff; transform: translateY(-2px); }
    &.active { background: #1677ff; color: #fff; i, span { color: #fff; } }
    i { font-size: 24px; margin-bottom: 8px; color: #1677ff; }
    span { font-size: 12px; color: #1f2d3d; text-align: center; }
  }
}
</style>